'use client';
import { objectEntries } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function parseHotkey(hotkey) {
    const keys = hotkey.toLowerCase().split('+').map((part)=>part.trim());
    const modifiers = {
        alt: keys.includes('alt'),
        ctrl: keys.includes('ctrl'),
        meta: keys.includes('meta'),
        mod: keys.includes('mod'),
        shift: keys.includes('shift')
    };
    const reservedKeys = [
        'alt',
        'ctrl',
        'meta',
        'shift',
        'mod'
    ];
    const freeKey = keys.find((key)=>!reservedKeys.includes(key));
    return _extends({}, modifiers, {
        key: freeKey
    });
}
function isExactHotkey(hotkey, event) {
    const { alt, ctrl, meta, mod, shift, key } = hotkey;
    const { altKey, ctrlKey, metaKey, shiftKey, key: pressedKey } = event;
    if (alt !== altKey) {
        return false;
    }
    if (mod) {
        if (!ctrlKey && !metaKey) {
            return false;
        }
    } else {
        if (ctrl !== ctrlKey) {
            return false;
        }
        if (meta !== metaKey) {
            return false;
        }
    }
    if (shift !== shiftKey) {
        return false;
    }
    if (key && (pressedKey.toLowerCase() === key.toLowerCase() || event.code.replace('Key', '').toLowerCase() === key.toLowerCase())) {
        return true;
    }
    return false;
}
function getHotkeyMatcher(hotkey) {
    return (event)=>isExactHotkey(parseHotkey(hotkey), event);
}
function getHotkeyHandler(hotkeys) {
    return (event)=>{
        const _event = 'nativeEvent' in event ? event.nativeEvent : event;
        for (const [hotkey, handler] of objectEntries(hotkeys)){
            if (getHotkeyMatcher(hotkey)(_event)) {
                handler(_event);
            }
        }
    };
}

export { getHotkeyHandler, getHotkeyMatcher, parseHotkey };
//# sourceMappingURL=parseHotkeys.js.map
